/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useEffect, useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import { AppContext, withAppContext } from '@ctsu/loader';
import Select from 'react-select';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import bindLogger from 'helpers/BindLogger';
import { ATCONSTANTS as ATC } from 'appconstants';
import { openConfirmation } from 'components/Confirmation/Confirmation';
import ModalFooter from 'components/ModalFooter/ModalFooter';
import {
  getEmailPhoneDetails, getTrackingCodes, setIndexing, generateTrackingcode
} from 'actions/packet';
import PersonTypeAhead from 'components/Fields/typeAheads/PersonTypeAhead';

const DEBOUNCE_TIME = 500;
const COMMUNICATION_OPTIONS = ['SITE_INQUIRY', 'MISC_INQUIRY', 'LPO_INQUIRY'];
let timeoutId;

// setSelectedLabel -> used to store the user selected lable
// holds the user last selected lable
// set the lable on change of any value
// clear it while close/open edit mode and on close/save of communicate modal.
function SelectField({
  label,
  value,
  options,
  getDisableCheck,
  setIsObjectDirty,
  data,
  setData,
  attr,
  att,
  openCommmunicate,
  takeComm,
  setSelectedLabel,
  selectedLabel,
  controller,
  packet,
  appliedFilters,
  saveHandler,
  closeComModal,
  cancelModel
}) {
  let modal;

  const checkStatus = useCallback((currentVal) => {
    if (
      (data.object === 'ENROLLMENT_TRANSFERS' && takeComm)
      || (data.object === 'ENROLLMENT_TRANSFERS' && att !== 'IN_PROGRESS' && currentVal === 'IN_PROGRESS')
    ) {
      return true;
    }
    return att !== currentVal && COMMUNICATION_OPTIONS.includes(currentVal);
  }, [att, data.object, takeComm]);

  useEffect(() => {
    if (selectedLabel === 'Packet Status' && checkStatus(value)) {
      const extraProps = {
        controller, editedDetails: data, packetId: packet.packetId, appliedFilters, saveHandler, closeComModal, cancelModel
      };
      openCommmunicate(true, value, extraProps);
    }
  }, [data, packet.packetId, selectedLabel, appliedFilters, saveHandler, closeComModal, cancelModel, value, checkStatus, controller, openCommmunicate]);

  const changeVal = (selectedVal) => {
    if (selectedVal != null) {
      if (label === 'Object') {
        // compare with previous data in the data object
        setIsObjectDirty(true);
        const onAction = () => {
          setSelectedLabel(null);
          setData({ ...data, [attr]: selectedVal.value });
          modal.handleClose();
        };
        const cancelBtnHandler = () => {
          setSelectedLabel(null);
          setData({ ...data, [attr]: data.object });
          modal.handleClose();
        };
        modal = openConfirmation({
          header: `Confirm Object Type Update`,
          message: `Please confirm you want to update the Object Type for this packet to ${selectedVal.label}. Values in the Indexing grid which are not relevant to ${selectedVal.label} packets will be removed.`,
          isClose: false,
          modalFooter: (
            <ModalFooter
              firstBtnName="Confirm"
              secondBtnName="Cancel"
              frstDataId={`${ATC.PACKETID}PACKET_CONFIRM${ATC.BUTTON}`}
              secondDataId={`${ATC.PACKETID}PACKET_CANCEL${ATC.BUTTON}`}
              firstBtnHandler={onAction}
              secondBtnHandler={cancelBtnHandler}
            />
          )
        });
      } else {
        setData({ ...data, [attr]: selectedVal.value });
      }
    }
    setSelectedLabel(label);
  };

  return (
    <Select
      isClearable
      isValid
      value={{ label: value, value }}
      data-id={`${ATC.PACKETID}${data.id}_${attr}${ATC.SELECT}`}
      isDisabled={getDisableCheck()}
      options={options}
      onChange={changeVal}
      menuPortalTarget={document.querySelector('body')}
      className="reactSelect-wrapper"
      classNamePrefix="reactSelect"
    />
  );
}

const selectStyles = {
  menuPortal: (base) => ({
    ...base,
    zIndex: 1000
  })
};

const fetchData = (searchText, setCodeoptions, getApi, context) => {
  const postData = {
    first: 0,
    size: 20,
    isMetaRequired: false,
    filter: [{ field: 'trackingBarCode', operation: 'contains', value: searchText }]
  };

  return bindLogger(
    getApi,
    context
  )(postData).subscribe((resp) => {
    let trackCodes = [];
    trackCodes = resp.data.map((x) => x.trackingBarCode);
    trackCodes = Array.from(new Set(trackCodes));
    if (trackCodes != null && trackCodes.length > 0) {
      const opts = trackCodes.map((x) => ({
        label: x,
        value: x
      }));
      setCodeoptions(opts);
    }
    return [];
  });
};

const inputChangeValCheck = (val, setCodeoptions, getApi, context) => {
  const letter = val.trim().toUpperCase() === 'SCP' ? 'SCP' : 'SCP-';
  const lenCheck = val.trim().toUpperCase().indexOf(letter) >= 0 ? val.trim().length > 6 : val.trim().length > 2;
  if (lenCheck) {
    fetchData(val.trim(), setCodeoptions, getApi, context);
  } else {
    setCodeoptions([]);
  }
};

const onInputChange = (val, setCodeoptions, getApi, context) => {
  if (timeoutId != null) {
    clearTimeout(timeoutId);
  }
  timeoutId = setTimeout(() => {
    if (val != null) {
      inputChangeValCheck(val, setCodeoptions, getApi, context);
    }
  }, DEBOUNCE_TIME);
};

function PopupContent(props) {
  const {
    value, data, attr, setVal, getApi, onNewchange
  } = props;
  const [codeOptions, setCodeoptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState({ label: value, value });
  const context = useContext(AppContext);
  
  return (
    <Select
      isClearable
      isValid
      value={selectedValue}
      styles={selectStyles}
      data-id={`${ATC.PACKETID}${data.id}_${attr}${ATC.SELECT}`}
      isDisabled={false}
      options={codeOptions}
      onChange={(trackcodeVal) => onNewchange(trackcodeVal, setSelectedValue, setVal)}
      onInputChange={(trackcodeVal) => onInputChange(trackcodeVal, setCodeoptions, getApi, context)}
      menuPortalTarget={document.querySelector('body')}
      className="reactSelect-wrapper"
      classNamePrefix="reactSelect"
    />
  );
}

function InputField({
  value,
  getApi,
  getDisableCheck,
  data,
  setData,
  attr,
  onClicktrackingCodeStatus,
  LinkButton
}) {
  const [val, setVal] = useState(value);
  const [isConfirm, setIsConfrim] = useState(false);
  
  const onProcess = useCallback(() => {
    if (val) {
      setData({ ...data, [attr]: val });
      setIsConfrim(false);
    }
  },[val, attr, setData, data]);

  useEffect(() => {
    if(isConfirm) {
      onProcess();
    }
      
  }, [isConfirm, onProcess]);

  const openPopup = () => {
    let modal;

  const onCancel = () => {
    setIsConfrim(false);
    modal.handleClose();
  };
    
  const onConfirm = () => {
    setIsConfrim(true);
    modal.handleClose();
  } 
  
  const onNewchange = (trckvalue, setSelectedValue) => {
    setSelectedValue(trckvalue);
    setVal(trckvalue.value);
  };
    
    modal = openConfirmation({
      modalSize: 'sm',
      header: 'Enter Tracking Code',
      modalFooter: (
        <ModalFooter
          firstBtnName="Confirm"
          secondBtnName="Cancel"
          frstDataId={`${ATC.PACKETID}${data.id}_OK${ATC.BUTTON}`}
          secondDataId={`${ATC.PACKETID}${data.id}_CANCEL${ATC.BUTTON}`}
          firstBtnHandler={onConfirm}
          secondBtnHandler={onCancel}
        />
      ),
      renderComp: () => <PopupContent onNewchange={onNewchange} getApi={getApi} data={data} setData={setData} attr={attr} setVal={setVal} value={value} />,
      isClose: false
    });
  };
  return (
    <div className="row">
      <div className="col-6">
        <input
          type="text"
          className="mb-1" // form-control
          data-id={`${ATC.PACKETID}${data.id}_${attr}${ATC.INPUT}`}
          value={value}
          aria-label={`${ATC.PACKETID}${data.id}_${attr}${ATC.INPUT}`}
          placeholder="Enter Tracking Code"
          disabled
        />
      </div>
      <div className="col-6 whiteSpace-nowrap align-self-center">
        <LinkButton onClick={onClicktrackingCodeStatus} title="Tracking Bar Code Status" name="Status" />
        <button
          data-id={`${ATC.PACKETID}${data.id}_SEARCH${ATC.BUTTON}`}
          type="button"
          className="fn-btn mx-1"
          title="Search"
          onClick={openPopup}
          disabled={getDisableCheck()}
        >
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </div>
    </div>
  );
}

function TextAreaField({
  value, setData, data, attr
}) {
  const onChange = (evt) => {
    setData({ ...data, [attr]: evt.target.value });
  };

  return (
    <div className="form-layout-input">
      <textarea
        type="text"
        data-id={`${ATC.PACKETID}${data.id}_${attr}${ATC.TEXTAREA}`}
        className="mt-0 bg-transparent color-black" // form-control
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

function ReadOnlyField({ value, label }) {
  return (
    <input
      data-id={`${ATC.PACKETID}${label.split(' ').join('_').toUpperCase()}${ATC.INPUT}`}
      type="text"
      className="bg-transparent" // form-control
      value={value || ''}
      disabled
      placeholder={label}
    />
  );
}

// eslint-disable-next-line complexity
function EditAdditionalDetails(props) {
  const {
    metaData, getEmailPhoneDetailsAction, getTrackingcodelist, deleteIndexing, takeComm, ...otherProps
  } = props;
  const {
    label, setData, context, data, attr, setIsObjectDirty, setSelectedLabel, selectedLabel
  } = props;
  const filteredData = (() => {
    const l = label === 'Packet Status' ? 'Status' : label;
    return metaData && metaData.filter((x) => x.title === l);
  })();

  let availableOpts = [];
  if (filteredData && filteredData[0] && filteredData[0].options) {
    availableOpts = filteredData[0].options;
    if (attr === 'status') {
      availableOpts = availableOpts.filter(
        (x) => x.label !== 'New' && x.label !== 'Not Complete' && x.label !== 'Cirb' && x.label !== 'Working'
      );
    }
  }

  const onChange = (val) => {
    if (label === 'Contact' && val != null) {
      const [name, id] = val.label.split('|');
      if (data.contact !== name.trim() && id) {
        bindLogger(
          getEmailPhoneDetailsAction,
          context
        )(id.trim()).subscribe((resp) => {
          const { personEmailId, phoneNumber } = resp.response;
          setData({
            ...data,
            contact: name.trim(),
            emailId: personEmailId,
            phone: phoneNumber,
            contactCtepId: id.trim()
          });
        });
      }
    }
    if (label === 'Contact' && val == null && data.contact !== '') {
      setData({
        ...data, contact: '', emailId: '', phone: '', contactCtepId: null
      });
    }
  };

  const value = data[attr];
  const isSr = otherProps.indexingRows.some((x) => x.isSR) || false;
  const getDisableCheck = () => {
    let isDisabled = false;
    if (label === 'Object') {
      if (data.object === 'SITE_REGISTRATION') {
        isDisabled = isSr;
      } else {
        isDisabled = data.isProcessed;
      }
    }
    return isDisabled;
  };

  switch (label) {
    case 'Tracking Code':
      return (
        <InputField {...otherProps} value={value} getApi={getTrackingcodelist} getDisableCheck={getDisableCheck} />
      );
    case 'Other Contact':
    case 'Internal Comments':
    case 'External Comments':
    case 'Content':
      return <TextAreaField {...otherProps} value={value || ''} />;
    case 'Contact':
      return <PersonTypeAhead onChange={onChange} value={{ label: data[attr], value: data[attr] }} />;
    case 'Email':
    case 'Phone':
      return <ReadOnlyField {...otherProps} value={value} />;
    case 'Object':
    case 'Priority':
    case 'Assigned To':
    case 'Type':
    case 'Packet Status':
    case 'Packet Class':
    default:
      return (
        <SelectField
          setSelectedLabel={setSelectedLabel}
          selectedLabel={selectedLabel}
          getDisableCheck={getDisableCheck}
          options={availableOpts}
          deleteIndexing={deleteIndexing}
          {...otherProps}
          fieldLabel={label}
          value={value}
          setIsObjectDirty={setIsObjectDirty}
          takeComm={takeComm}
        />
      );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  getEmailPhoneDetailsAction: getEmailPhoneDetails,
  getTrackingcodelist: getTrackingCodes,
  generateTrackingCodeApi: generateTrackingcode,
  deleteIndexing: setIndexing
};

export default withAppContext(connect(mapStateToProps, mapDispatchToProps)(EditAdditionalDetails));
